export default __webpack_public_path__ + "static/media/gitbook-icon.0d78c7be.svg";